/* global API_BASE_URL */

import { apiRepositoryFactory } from '@/factories/apiRepositoryFactory.js'
import axios from 'axios'

const createApiRepositories = (tagParams) => {
  axios.defaults.baseURL = API_BASE_URL;
  axios.defaults.headers.common['Tenant-Id'] = tagParams.tenantId;

  const url = new URL(window.location.href);
  const previewCampaignId = url.searchParams.get('_storeeel_preview_campaign_id');

  if (previewCampaignId) {
    url.searchParams.delete('_storeeel_preview_campaign_id');
    axios.defaults.headers.common['Current-URL'] = url.toString();  // 除去後のURLを設定
  } else {
    axios.defaults.headers.common['Current-URL'] = window.location.href;
  }

  return {
    get: (name) => apiRepositoryFactory.get(name)(axios),
  }
}

export default createApiRepositories
